import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
const { md } = { ...baseVariables.mediaQuery };

export const StyledOffersMerchandisingSerpBanner = styled.div`
  .offers-merchandising-serp-banner {
    .merchandising-serp-banner {
      @media ${md} {
        &__image {
          &-logo {
            left: 12px;
            bottom: 12px;
            max-width: 150px;
          }
        }
      }
      .merchandising-serp-banner__content-bullets {
        @media ${md} {
          span.icon-black-offers:before {
            width: 12px;
            height: 12px;
          }
        }
      }
      .m-badge-black-offers {
        background: var(--Colors-neutral-10, #f4f4f4);
        color: var(--Colors-base-10, #1c1c1c);
      }
      .icon-black-offers::before {
        color: var(--Colors-base-10, #1c1c1c);
      }
    }
  }
`;
